export default function humanReadableDate(
  dateString: string,
  alwaysThe = false,
) {
  const payday = new Date(`${dateString} 12:00:00`)
  const ordinalSuffixIndicatorRegex = /\/[0-3]?([0-9]{1})\//.exec(
    payday.toLocaleDateString('en-us'),
  )

  if (isNaN(payday.getTime()) || ordinalSuffixIndicatorRegex === null) {
    return 'PAYDAY NOT SET'
  }

  const today = new Date()
  const paydayDate = payday.getDate()
  const ordinalSuffixIndicator = ordinalSuffixIndicatorRegex[1]

  const ordinalSuffixMap: Record<string, string> = {
    '1': 'st',
    '2': 'nd',
    '3': 'rd',
  }
  let prefix = 'the'
  let ordinalSuffix = 'st'
  //set "this" vs "next" depending on the month
  if (payday.getMonth() > today.getMonth() && alwaysThe !== false) {
    prefix = 'next'
  }

  //Set the ordinal indicator based on the date (st, nd, rd, th)
  switch (true) {
    case paydayDate > 10 && paydayDate < 20:
      ordinalSuffix = 'th'
      break
    case ordinalSuffixMap[ordinalSuffixIndicator] !== undefined:
      ordinalSuffix = ordinalSuffixMap[ordinalSuffixIndicator]
      break
    default:
      ordinalSuffix = 'th'
      break
  }

  return `${prefix} ${payday.getDate()}${ordinalSuffix}`
}
